import {WhiteCard} from "../_components/WhiteCard";
import React from "react";
import {useAuth} from "../../../context";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {useTopicSSE} from "../../../hooks/useTopicSSE";
import {SseTopics} from "../../../context/SSEContext";
import {useGetJson, usePostJson} from "../../../hooks";
import {capitalizeFirstLetter, endpoints, RepeatType, timeUTCMinToLocalString} from "../../../utils2";
import {DeviceProject, EventType1, EventType2, ProjectMap, RelayAction} from "../../../utils2/maps";
import {Alert, Badge, Button, InputGroup} from "react-bootstrap";
import {nextMap, stateMap} from "../DashboardDevice";
import {buildEventSteps} from "../configure/utils";
import {RenderDailyShort} from "../_components/UsefulComponents";

export function NextControlSection({device}) {
    return <>
        <WhiteCard className="flex-fill">
            <NextControlCard device={device}/>
        </WhiteCard>
    </>
}

function NextControlCard({device}) {
    const {authToken} = useAuth()
    const {uid, did} = useParams()
    const location = useLocation();

    const navigate = useNavigate()
    const online = useTopicSSE(SseTopics.Online)
    const next = useTopicSSE(SseTopics.Next)

    const stream = useTopicSSE(SseTopics.Stream)
    const vol = useTopicSSE(SseTopics.VOL)

    const isStopped = stateMap[stream?.state] === "Stopped"
    const isFailed = stateMap[stream?.state] === "Failed"
    const isScheduled = nextMap[next?.state]?.status === "Scheduled"

    // const [liveControlPush, liveControlValue, liveControlLoadingPush, liveControlErrorPush, clearLiveControlErrorPush] = usePostJson(endpoints.push.liveControl(uid, did), authToken?.jwt)
    //
    // function handlePlayClick(state) {
    //     liveControlPush({state, index: 0})
    // }


    // const mycall = useCallback(() => useGetJson(endpoints.event.get(next?.uuid), authToken?.jwt), [])
    // const [ev, loadingDevice, errorDevice, clearErrorDevice] = mycall()

    // const uuid = useMemo(() => next?.uuid, [next?.uuid])
    // const url = useCallback(() => endpoints.event.get(uuid), [uuid])

    const [ev, loadingEv, errorEV, clearErrorEv] = useGetJson(next?.uuid ? endpoints.event.get(next.uuid) : null, authToken?.jwt)
    const event = ev?.data
    const config1 = event?.config1
    const config2 = event?.config2

    {/*
        NONE = 0; // No events available
        STOP = 1; // Stopping underrun + UUID that is under stopping
        NEXT = 2; // Next UUID scheduled
        PLAY = 3; // UUID in execution
        */
    }

    function formatKey(str) {
        const parts = [
            str?.slice(0, 8),
            str?.slice(8, 12),
            str?.slice(12, 16),
            str?.slice(16, 20),
            str?.slice(20)
        ];
        return parts.join("-");
    }

    const correctNextUUID = formatKey(next?.uuid)

    const advConfig = (ProjectMap.find(item => item.project === device?.device_project)?.configure)?.find(item => item?.event_type2 === event?.event_type2)?.advPlayback

    return <>
        <Alert variant="danger" show={errorEV} dismissible onClose={clearErrorEv}>{errorEV}</Alert>

        <div className="d-flex align-items-center gap-2 mb-2">
            <Badge bg={!(online && next?.uuid) ? "secondary" : (isStopped || isFailed) ? "danger" : "info"}>
                <div className="d-flex align-items-center gap-2">NEXT <i
                    className={online && event?.event_type1 ? "fs-5 bi bi-bell" : "fs-5 bi bi-bell-slash"}/></div>
            </Badge>
            {online && <div>
                {event?.event_type1 === EventType1.Automation ? "Automation"
                    : event?.event_type1 === EventType1.ControlledBy ? "Controlled-By"
                        : ""
                }
            </div>}
        </div>

        <div className="d-flex align-items-start gap-2 mb-2">
            <div>
                {/*Event name and type2*/}
                {online && event?.event_type2 && <div><Button variant="link"
                                                              className="p-0 link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover"
                                                              onClick={() => buildEventSteps(uid, did, event?.event_type2, advConfig, location, navigate, event?.event_type1, correctNextUUID, 2)}>
                    <div>{event?.name} ({event?.event_type2 === EventType2.Playback ? "Playback"
                        : event?.event_type2 === EventType2.Sender ? "Sender"
                            : event?.event_type2 === EventType2.Relay1 ? "Relay 1" : ""})
                    </div>
                </Button></div>
                }

                {/*Event Status*/}
                {online && next?.state > 0 && <>
                    <div>{nextMap.find(n => n.id === next?.state)?.status}</div>
                </>}

                {/*Relay Action*/}
                {online && event?.event_type2 === EventType2.Relay1 &&
                    // <Link to={`/device/${uid}/${did}/relay1/${correctNextUUID}`}
                    //       className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                    //     <span>{RelayAction[config2?.action].name}</span></Link>}
                    <Button variant="link" className="p-0 link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover"
                            onClick={() => buildEventSteps(uid, did, event?.event_type2, advConfig, location, navigate, event?.event_type2, correctNextUUID, 1)}>
                        {/*onClick={() => buildEventSteps(uid, did, "time", advConfig, location, navigate, event?.event_type2, correctNextUUID, 1)}>*/}
                        <span>{RelayAction[config2?.action].name}</span>
                    </Button>}

                {/*Broadcaster event automation*/}
                {online && event?.event_type1 === EventType1.Automation && event?.name !== "ALWAYS" && (
                    <Button variant="link" className="p-0 link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover"
                            onClick={() => buildEventSteps(uid, did, event?.event_type2, advConfig, location, navigate, event?.event_type1, correctNextUUID, 1)}>
                        <div className="d-flex">
                            {config1.repeat === RepeatType.Daily ? (
                                <RenderDailyShort config1={config1} textStyle="fw-normal"/>
                            ) : (
                                <div>{`${capitalizeFirstLetter(config1.weekly_start.slice(0, 3))} - ${capitalizeFirstLetter(config1.weekly_stop.slice(0, 3))}`}</div>
                            )}
                            <div className="me-1">;</div>
                            <div>
                                {`${timeUTCMinToLocalString(config1?.time_start)} - ${timeUTCMinToLocalString(config1?.time_stop)}`}
                            </div>
                        </div>
                    </Button>
                )}

                {/*Not Online*/}
                {!online || !(event?.event_type1 === EventType1.Automation || event?.event_type1 === EventType1.ControlledBy || event?.name === "ALWAYS") &&
                    <Link to={`/device/${uid}/${did}/config`}
                          className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">Set
                        event</Link>}
            </div>
            <div className="ms-auto">
                {(online || event) && <LiveControlSection device={device}/>}
                {/*<InputGroup>*/}
                {/*    <Button variant="success" disabled={!online || !next?.uuid} onClick={() => handlePlayClick(true)}>START</Button>*/}
                {/*    <Button variant="danger" disabled={!online || !next?.uuid} onClick={() => handlePlayClick(false)}>STOP</Button>*/}
                {/*</InputGroup>*/}
            </div>
        </div>


    </>

}

function LiveControlSection({device}) {
    const {authToken} = useAuth()
    const {uid, did} = useParams()

    const [liveControlPush, liveControlValue, liveControlLoadingPush, liveControlErrorPush, clearLiveControlErrorPush] = usePostJson(endpoints.push.liveControl(uid, did), authToken?.jwt)

    function handleRelayClick(state, index) {
        liveControlPush({state, index})
    }

    function handlePlayClick(state) {
        liveControlPush({state, index: 0})
    }


    return <>
        <Alert variant="danger" show={liveControlErrorPush} dismissible onClose={clearLiveControlErrorPush}>{liveControlErrorPush}</Alert>
        <LiveControl device={device} handleRelayClick={handleRelayClick} handlePlayClick={handlePlayClick}/>
    </>
}

function LiveControl({device, handleRelayClick, handlePlayClick}) {
    const project = ProjectMap.find(i => i.project === device?.device_project)

    const relay = useTopicSSE(SseTopics.Relay)

    if (project?.project === DeviceProject.RelayNano)
        return <>
            {project.configure.map((conf, idx) =>
                <LiveRelay key={idx} idx={idx} relay={relay} handleRelayClick={handleRelayClick}/>
            )}
        </>
    else if (project?.project === DeviceProject.StandardEth || project?.project === DeviceProject.MicroEth || project?.project === DeviceProject.NanoEth)
        return <>
            <LiveBroadcaster onPlayClick={handlePlayClick}/>
        </>
    else
        return null
}

function LiveRelay({idx, relay, handleRelayClick}) {
    const online = useTopicSSE(SseTopics.Online)

    return <>
        {/*<div className="d-flex align-items-center justify-content-between mb-1 mt-1">*/}
        {/*    <div className="d-flex align-items-center gap-2">*/}
        {/*        {online ?*/}
        {/*            <Badge bg={relay?.states[idx] ? "success" : "danger"}>*/}
        {/*                <div className="d-flex align-items-center gap-1">{relay?.states[idx] ? "ON" : "OFF"}*/}
        {/*                    <i className={relay?.states[idx] ? "fs-5 bi bi-lightbulb" : "fs-5 bi bi-lightbulb-off"}/></div>*/}
        {/*            </Badge>*/}
        {/*            : <Badge bg="secondary"><i className="fs-5 bi bi-lightbulb-off"/></Badge>}*/}
        {/*        <div>Relay {idx + 1}</div>*/}
        {/*    </div>*/}
        {/*    <div>*/}
                <InputGroup>
                    <Button variant="success" disabled={!online}
                            onClick={() => handleRelayClick(true, idx)}>Turn On</Button>
                    <Button variant="danger" disabled={!online}
                            onClick={() => handleRelayClick(false, idx)}>Turn Off</Button>
                </InputGroup>
        {/*    </div>*/}
        {/*</div>*/}
    </>
}

function LiveBroadcaster({onPlayClick}) {
    const online = useTopicSSE(SseTopics.Online)
    const next = useTopicSSE(SseTopics.Next)

    return <>

        <InputGroup>
            <Button variant="success" size="sm" disabled={!online || !next?.uuid} onClick={() => onPlayClick(true)}>START</Button>
            <Button variant="danger" size="sm" disabled={!online || !next?.uuid} onClick={() => onPlayClick(false)}>STOP</Button>
        </InputGroup>

    </>
}